/**
 * Returns the index of first element which return true for the callback fn
 * @param {*} array array to lookup on
 * @param {*} callback
 * @returns index of element, -1 if not found
 */
export const findIndexInArray = (array, callback) => {
  try {
    for (let i = 0; i < array.length; i++) {
      if (callback(array[i])) {
        return i;
      }
    }
    return -1;
  } catch (error) {
    return -1;
  }
};

/**
 * Updates or create a new array.
 * @param {Array} array array to iterate on
 * @param {Function} actionFn function to calculate or perform action
 * @param {Boolean} createANewArray true if wants to create a new array behaves as map fn of an array else forEach
 * @returns new array or undefined based in createANewArray value
 */
export const iterateForEachElementInArray = (array, actionFn, createANewArray) => {
  const newArray = [];

  for (let i = 0; i < array.length; i++) {
    if (createANewArray) {
      newArray.push(actionFn(array[i]));
    } else {
      array[i] = actionFn(array[i]);
    }
  }

  return createANewArray ? newArray : undefined;
};

export const includesInArray = (array, element) =>
  findIndexInArray(array, (item) => item === element) !== -1;

export const includesInString = (string, substring) => {
  const array = string.split(substring);
  // if length is >= 2 then substring exists
  return array.length > 1;
};

/**
 * Checks if an element or substring exists
 * @param {*} object String or Object
 * @param {*} element element or substring to search for
 * @returns {Boolean} true if exist else false
 */
export const includes = (object, element) => {
  if (typeof object === 'string') {
    return includesInString(object, element);
  } else if (Array.isArray(object)) {
    return includesInArray(object, element);
  }
};

export const getObjectValues = (object) =>
  iterateForEachElementInArray(Object.keys(object), (key) => object[key], true);
